// React libs
import React, { FC } from 'react';
import get from 'lodash/get'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardDateTimePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { TextField } from '@material-ui/core';
// Components
import FieldError from '../../Error/FieldError/FieldError';
// Type
import * as Types from './DatePicker.type';
// Utils
import { hasErrors } from '../../../../Utils/FormUtils'

const DatePicker: FC<Types.IProps> = ({
  field,
  form,
  iconColor,
  label,
  needTime,
  transform = value => value,
  ...props
}) => {
  const { errors, touched } = form;
  const customField = {
    ...field,
    onChange: (date: Date | null) => {
      form.setFieldValue(field.name, transform(date));
    },
  };
  const mixedProperties = {
    label,
    clearable: true,
    format: 'DD/MM/YYYY HH:mm:ss',
    ampm: false,
    margin: 'none',
    value: field.value,
    KeyboardButtonProps: {
      'aria-label': 'change date',
    },
    classes: { root: 'w-full' },
    invalidDateMessage: 'Date invalide',
    maxDateMessage: 'Date supérieure à la date max autorisée',
    minDateMessage: 'Date inférieure à la date min autorisée',
    clearLabel: 'Effacer',
    cancelLabel: 'Annuler',
    todayLabel: 'Maintenant',
    TextFieldComponent: (props: any) => <TextField {...props} />,
    error: touched[field.name] && errors[field.name] !== undefined,
    ...customField,
    ...props,
  };

  return (
    <div className='w-full' data-testid='datepicker'>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        {needTime ? (
          <KeyboardDateTimePicker {...mixedProperties} />
        ) : (
          <KeyboardDatePicker {...mixedProperties} />
        )}
      </MuiPickersUtilsProvider>
      {hasErrors(form, field.name) && (
        <FieldError
          color={props.color}
          errors={get(errors, field.name)}
          touched={touched}
        />
      )}
    </div>
  );
};

DatePicker.defaultProps = {
  iconColor: 'white',
  needTime: false,
};

export default DatePicker;
